// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iEo74","rootMobile":"styles_rootMobile__1FkJ4"};